/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { ChangeEvent, FC } from "react";
import { Control, Controller } from "react-hook-form";

import TestIds from "../../../testIds";
import SelectFormControl, {
  ISelectOption,
} from "../../form-controls/SelectFormControl/SelectFormControl";

import { EReasonCode, EUnitPriceFields, TUnitPriceFormData } from "./types";

export interface IFormControlReasonCodeProps {
  control: Control<TUnitPriceFormData>;
  validateField: (errorMessage: string) => (value?: string) => string | true;
  clearError: () => void;
}

export const REASON_CODE_OPTIONS: ISelectOption[] = Object.entries(EReasonCode).map(
  ([key, value]: [string, EReasonCode]) => ({
    value,
    label: key.replace(/([A-Z])/g, " $1").trim(),
  })
);

export const FormControlReasonCode: FC<IFormControlReasonCodeProps> = ({
  control,
  validateField,
  clearError,
}) => (
  <Controller
    name={EUnitPriceFields.ReasonCode}
    control={control}
    rules={{ validate: validateField("Please enter a reason") }}
    render={({ field, fieldState: { error } }) => (
      <SelectFormControl
        id={EUnitPriceFields.ReasonCode}
        data-testid={TestIds.components.forms.unitPriceForm.reasonField}
        farmlands-variant={"farmlands2.0_default"}
        labelColor="secondary"
        label="Reason"
        placeholder="Select reason"
        error={!!error}
        required
        value={field.value}
        errorMessage={error?.message}
        inputProps={{
          autoComplete: "off",
          onChange: (event: ChangeEvent<HTMLInputElement>) => {
            field.onChange(event);
            if (error) {
              clearError();
            }
          },
          onBlur: field.onBlur,
        }}
        options={REASON_CODE_OPTIONS}
      />
    )}
  />
);
